import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { $document } from "../document-list";
import { docsListItemType } from "../document-list/document-list.types";

const TEMPLATE_WORKSPACE_NAME = "moment-templates";

/**
 * Returns true when a document is a template — either any of its remote
 * entries belong to the `moment-templates` workspace, or its type (from
 * moment.yml / remote metadata) is "template".
 */
export const $isTemplate = atomFamily((documentId: string | undefined) => {
	const $isTemplateAtom = atom((get) => {
		if (!documentId) {
			return false;
		}

		const doc = get($document(documentId));
		if (!doc) {
			return false;
		}

		// Check ALL remote entries — a locally checked-out template may have
		// multiple remote entries and the moment-templates one might not be first.
		const remoteEntries = Object.values(doc.remote);
		if (remoteEntries.some((entry) => entry.workspace?.name === TEMPLATE_WORKSPACE_NAME)) {
			return true;
		}

		// Check document type from moment.yml (local) or remote metadata
		if (docsListItemType(doc) === "template") {
			return true;
		}

		return false;
	});
	$isTemplateAtom.debugLabel = `isTemplate/${documentId}`;
	return $isTemplateAtom;
});
